import { ReactElement } from 'react';

import { QueueUnknownParam } from './params/QueueUnknownParam';
import { QueueTypeHandler } from '../QueueTypeHandler';

export class DefaultHandler extends QueueTypeHandler {
    readonly extensionsAccepted: readonly string[] = [];

    renderParams(): ReactElement {
        return <QueueUnknownParam />;
    }
}
